import { useState, useEffect, useCallback } from 'react'

import toast from 'Utils/toast'

import { mySalesService } from '../Services/mySalesService'

export const useDonations = () => {
  const [donations, setDonations] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [donationRate, setDonationRateValue] = useState('')
  const [error, setError] = useState(null)
  const [isParticipating, setIsParticipating] = useState(true)
  const [originalValues, setOriginalValues] = useState({
    donationRate: '',
    isParticipating: true,
  })

  const setDonationRate = (selectedOption) => {
    setDonationRateValue(selectedOption.value)
  }

  const fetchDonations = useCallback(async () => {
    setIsLoading(true)
    setError(null)

    try {
      const response = await mySalesService.getDonations()

      setDonations(response)
    } catch (err) {
      setError('Unable to load donations. Please try again.')
    } finally {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchDonations()
  }, [])

  useEffect(() => {
    if (!isParticipating) {
      setDonationRateValue('')
    }
  }, [isParticipating])

  useEffect(() => {
    if (donations.length > 0) {
      const isActive = donations[0].action !== 'Donation Ended'
      setIsParticipating(isActive)
      setOriginalValues({
        donationRate: isActive ? donations[0].donationRate.toString() : '',
        isParticipating: isActive,
      })
    }
  }, [donations])

  const handleCancel = () => {
    setDonationRateValue(originalValues.donationRate.toString())
    setIsParticipating(originalValues.isParticipating)
  }

  const handleConfirmDonationRate = async () => {
    if (isParticipating && !donationRate) {
      setError('Please select a percentage')
      return
    }

    try {
      if (!isParticipating) {
        const response = await mySalesService.disableDonations()
        if (response.status === 200) {
          toast({ text: 'Donation disabled' })
          fetchDonations()
        }
      } else {
        const response = await mySalesService.setDonationRate(donationRate)
        if (response.status === 200) {
          toast({ text: 'Donation rate saved' })
          fetchDonations()
        }
      }
    } catch (err) {
      toast({ text: 'Unable to update donation settings. Please try again.' })
      setError('Unable to update donation settings. Please try again.')
    }
  }

  return {
    donations,
    isLoading,
    error,
    donationRate,
    setDonationRate,
    handleConfirmDonationRate,
    isParticipating,
    setIsParticipating,
    handleCancel,
  }
}
